import React from 'react'
import Seo from '../../components/Seo'

const OATTMMusic = () => {
  return (
    <section className="trending-video-area">
        <div className="container">
          <Seo 
            title="OATTM – Music and soundtracks from the book series"
            description="Music from the Oliver and the Time Machine series. ChapterVerse is a journey of music following each chapter of the books."
            url="/music"
          />
          <div className="row align-items-center mb-30">
            <div className="col-sm-6">
              <div className="hf-section-title">
                <h1 className="title">OATTM - Music based on the book chapters</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
            <div className="trending-video-bookplay-item mb-50">
              <h5 className="mb-2">ChapterVerse Two - The Awakening</h5>
              <iframe 
                style={{borderRadius: "12px"}} 
                src="https://open.spotify.com/embed/album/0PX35jX0yyfoMqGgZjvzKC?utm_source=generator" 
                width="100%" 
                height="352" 
                frameBorder="0" 
                allowFullScreen="" 
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                loading="lazy"
                title="OATTM Spotify Album Placeholder"
              />
            </div>
          </div>
          <div className="col-12">
              <div className="trending-video-bookplay-item mb-50">
              <h5 className="mb-2">ChapterVerse One - The Beginning</h5>
                <iframe 
                  style={{borderRadius: "12px"}} 
                  src="https://open.spotify.com/embed/album/0LLry3OaRWyxe7bQ8FCqa7?utm_source=generator" 
                  width="100%" 
                  height="352" 
                  frameBorder="0" 
                  allowFullScreen="" 
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                  loading="lazy"
                  title="OATTM Spotify Album"
                />
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}

export default OATTMMusic